import { format, parseISO } from 'date-fns';

export default function DateFormatter(dateString, formats) {
    if (!dateString) return '';

    try {
        const date = parseISO(dateString);
        return format(date, formats);
    } catch (error) {
        console.error('Invalid date:', dateString, error);
        return '';
    }
}